import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {loadAllAxis} from "../axis/all-axis/axisAction";
import {loadProjects} from "../project/projects/projectsAction";
import styled from "styled-components";
import SelectAxisCard from "../axis/SelectAxisCard";

const SearchByAxis = ({data, setData, inActionPage}) => {
    const dispatch = useDispatch()
    const {axis} = useSelector(state => state.axis)
    const [axisSelected, setAxisSelected] = useState(0)

    useEffect(() => {
        dispatch(loadAllAxis())
        dispatch(loadProjects())
    }, [dispatch])

    useEffect(() => {
        return () => {
            setData(data)
        }
    }, [data, setData])

    useEffect(() => {
        if (axisSelected) {
            setData(data.filter(d => d.axisId === axisSelected))
        }
    }, [axisSelected,setData,data])

    const selectByAxis = (axis_id) => {
        setAxisSelected(axis_id)
    }
    return (
        <>
            <Container>
                {axis &&  axis.map(a => (<SelectAxisCard
                        key={a.id + "/" + a.name}
                        axisSelected={axisSelected}
                        selectByAxis={selectByAxis}
                        axis={a}
                    />))}
            </Container>
        </>)
}

const Container = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  max-width: 90%;
  justify-content: center;
`
export default SearchByAxis